import { useRef, useState } from 'react';
import { TransitionGroup } from 'react-transition-group';
import { usePM2DisplayContext } from '@pm2/store';
import { SizeTransition } from '@utils/react';
import { sliderWrapper, sliderContainer, slider, imageCaptionWrapper, CAPTION_TRANSITION_DURATION_MS, imageCaptionTransition } from './_slider.style.js';
import { Bullets } from './atom.bullets.js';
import { Chevrons } from './atom.chevrons.js';
import { Slide } from './atom.slide.js';
import { SlideCaption } from './atom.slide-caption.js';
import { useDragSlide } from './hook.drag-slide.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';

const SliderComponentSelector = "slider-component";
function SingularSlider(props) {
  const sliderRef = useRef(null);
  const {
    inLightbox
  } = usePM2DisplayContext();
  const [index, setIndex] = useState(props.options.initialIndex ?? 0);
  const [, dragProps] = useDragSlide(sliderRef, {
    amountOfSlides: props.slides.length,
    index,
    onChange: setIndex
  });
  const currentSlide = props.slides[index];
  const aspectRatio = Math.max(...props.slides.map(it => it.image.height / it.image.width));
  const firstSlide = props.slides?.[props.slides.length - 1];
  const lastSlide = props.slides?.[0];
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsxs("div", {
      className: sliderWrapper,
      "data-in-lightbox": inLightbox,
      children: [/*#__PURE__*/jsx("div", {
        ...dragProps,
        className: sliderContainer,
        style: {
          aspectRatio: `1 / ${aspectRatio}`
        },
        children: /*#__PURE__*/jsxs("div", {
          ref: sliderRef,
          className: slider,
          style: {
            transform: `translateX(-${index * 100}%)`
          },
          children: [firstSlide && /*#__PURE__*/jsx(Slide, {
            index: -1,
            model: firstSlide,
            isCurrent: false,
            handleOpenSlideInLightbox: () => props.handleOpenInLightbox(0)
          }), props.slides?.map((slide, index) => /*#__PURE__*/jsx(Slide, {
            index: index,
            model: slide,
            isCurrent: currentSlide === slide,
            handleOpenSlideInLightbox: () => props.handleOpenInLightbox(index)
          }, index)), lastSlide && /*#__PURE__*/jsx(Slide, {
            index: props.slides.length,
            model: lastSlide,
            isCurrent: false,
            handleOpenSlideInLightbox: () => props.handleOpenInLightbox(0)
          })]
        })
      }), props.slides.length > 1 && /*#__PURE__*/jsx(Chevrons, {
        onPrevClick: () => setIndex(prevIndex => prevIndex > 0 ? prevIndex - 1 : props.slides.length - 1),
        onNextClick: () => setIndex(prevIndex => (prevIndex + 1) % props.slides.length)
      }), props.slides.length > 1 && props.options.bulletType !== "thumb" && /*#__PURE__*/jsx(Bullets, {
        slides: props.slides,
        activeIndex: index,
        bulletType: props.options.bulletType,
        onBulletClick: setIndex
      })]
    }), props.displayCaption && /*#__PURE__*/jsx(TransitionableSlideCaption, {
      slide: currentSlide,
      transitionKey: String(index)
    }), props.slides.length > 1 && props.options.bulletType === "thumb" && /*#__PURE__*/jsx(Bullets, {
      slides: props.slides,
      activeIndex: index,
      bulletType: props.options.bulletType ?? "square",
      onBulletClick: setIndex
    })]
  });
}
function TransitionableSlideCaption(props) {
  const {
    inLightbox
  } = usePM2DisplayContext();
  return /*#__PURE__*/jsx(TransitionGroup, {
    className: imageCaptionWrapper,
    children: /*#__PURE__*/jsx(SizeTransition, {
      axis: "vertical",
      swappable: true,
      classNames: imageCaptionTransition,
      timeout: CAPTION_TRANSITION_DURATION_MS,
      children: ref => /*#__PURE__*/jsx(SlideCaption, {
        ref: ref,
        inLightbox: inLightbox,
        caption: props.slide?.caption
      })
    }, props.slide?.image.src)
  });
}

export { SingularSlider, SliderComponentSelector };
//# sourceMappingURL=_slider.js.map
